module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_animal_structure_and_function_4-636bf3067368e5db4a840d1f8e021995.jpg";